import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { deleteNew, fetchNews } from "../../services/NewsServices";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { Constants } from "../../Constants";
import { useHistory } from "react-router";

export default function NewsList() {
  const [loading, setLoading] = useState(false);
  const [news, setNews] = useState([]);
  const history = useHistory();

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchNews({
        token: "",
      });
      setNews(response.data.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const remove = async (id: number) => {
    setLoading(true);
    try {
      let response = await deleteNew({
        token: "",
        id,
      });
      setLoading(false);
      fetch();
      toast(`Noticia eliminado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      {loading && <Loading />}
      <Container fluid>
        <Breadcrumbs
          title="Listado de novedades"
          breadcrumbItem="Listado de novedades"
        />

        <Row style={{ marginBottom: "1rem" }}>
          <Col
            style={{
              alignItems: "end",
              display: "flex",
              justifyContent: "right",
            }}
          >
            <Button color="primary" onClick={() => history.push("/news/0")}>
              Agregar nueva novedad
            </Button>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0">
                <Table className="table table-striped table-bordered">
                  <Thead>
                    <Tr>
                      <Th></Th>
                      <Th>#</Th>
                      <Th>Tipo</Th>
                      <Th>Título</Th>
                      <Th>Descripción corta</Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {news.map((item: any) => (
                      <Tr>
                        <Th>
                          <img
                            data-dz-thumbnail=""
                            height="80"
                            className="avatar-sm rounded bg-light"
                            alt=""
                            src={`${Constants.BASE_URL}${item.image}`}
                          />
                        </Th>
                        <Th>{item.id}</Th>
                        <Th>{item.type}</Th>
                        <Th>{item.title}</Th>
                        <Th>{item.short_description}</Th>
                        <Th>
                          <button
                            className="button-action-left"
                            onClick={() => remove(item.id)}
                          >
                            Eliminar
                          </button>
                          |
                          <button
                            onClick={() => {
                              history.push(`/news/${item.id}`);
                            }}
                            className="button-action-rigth"
                          >
                            Editar
                          </button>
                        </Th>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
